import React from "react";

import Home from "../../Components/Home/Home";
import Header from "../../Components/Header/Header";

const HomePage = () => {
  return (
    <div>
      <Header />
      <Home />
    </div>
  );
};

export default HomePage;
